export enum env {
  Production = 'production',
  Sitetest1 = 'sitetest1',
  Sitetest2 = 'sitetest2',
  Sitetest3 = 'sitetest3'
}

const publicSubdomainsPrefixes = ['authorize', 'advertise', 'create'];
const internalSubdomainsPrefixes = ['admin', 'cs', 'mod', 'tools'];

/**
 * Examines the hostname to return the current environment
 * @returns the current environment
 */
export const getEnv = (): env => {
  const { hostname } = window.location;

  if (hostname.includes('localhost')) {
    return env.Sitetest3;
  }
  if (hostname.includes(env.Sitetest3)) {
    return env.Sitetest3;
  }
  if (hostname.includes(env.Sitetest2)) {
    return env.Sitetest2;
  }
  if (hostname.includes(env.Sitetest1)) {
    return env.Sitetest1;
  }

  return env.Production;
};

export const getTrustedOrigins = (parentOrigin?: string, getEnvironment = getEnv): string[] => {
  const environment = getEnvironment();
  switch (environment) {
    case env.Sitetest3:
    case env.Sitetest2:
    case env.Sitetest1: {
      const publicSubdomains = publicSubdomainsPrefixes.map(
        (prefix: string) => `https://${prefix}.${environment}.robloxlabs.com`
      );
      const internalSubdomains = internalSubdomainsPrefixes.map(
        (prefix: string) => `https://${prefix}.${environment}.simulpong.com`
      );
      let trustedOrigins = publicSubdomains
        .concat(internalSubdomains)
        .concat(`https://localhost.${environment}.robloxlabs.com:3000`, 'http://localhost:3000');

      // Check for special case of pr builds for creator hub.
      const prBuildRegex = new RegExp(
        `^https://([0-9]{1,5}[.])?(create)[.]${environment}[.]robloxlabs.com$`
      );
      if (parentOrigin && prBuildRegex.test(parentOrigin)) {
        trustedOrigins = trustedOrigins.concat(parentOrigin);
      }
      return trustedOrigins;
    }
    case env.Production: {
      const publicSubdomains = publicSubdomainsPrefixes.map(
        (prefix: string) => `https://${prefix}.roblox.com`
      );
      const internalSubdomains = internalSubdomainsPrefixes.map(
        (prefix: string) => `https://${prefix}.simulprod.com`
      );
      return publicSubdomains.concat(internalSubdomains);
    }
    default:
      return [];
  }
};
